<template>
  <div class="flex h-screen items-center justify-center bg-white">
    <WebSpinner />
  </div>
</template>

<script lang="ts" setup>
import WebSpinner from '@zotlo-shared/components/spinner/index.vue';
</script>
